import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-139a612d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "actor-warp"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "table-warp cms-card-block"
};
import Buttons from '@/components/Buttons/index.vue';
import PromotionCalender from './PromotionCalender/index.vue';
import AddOrEditPlan from './addOrEditPlan.vue';
import CheckDetailDialog from '../components/CheckDetailDialog.vue';
import { isArray } from '@/utils';
import { clearData } from '@/utils/tools';
import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig';
import { formValidator } from '@/utils/validate';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const formRef = ref(null);
    const checkDetailDialog = reactive({
      visible: false,
      loading: false
    });
    const addOrEditPlan = reactive({
      visible: false
    });
    const searchConfig = reactive({
      // size: { sm: 24, md: 12, lg: 8, xl: 6, xs: {} },
      formList: [{
        label: '关键字',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, {
        label: '促销时间段',
        prop: 'time',
        widgetType: 'date',
        placeholder: '请选择时间',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange'
      }, {
        label: '状态',
        prop: 'state',
        widgetType: 'Select',
        list: [{
          label: '全部',
          value: ''
        }, {
          label: '促销中',
          value: 1
        }, {
          label: '未开始',
          value: 2
        }, {
          label: '中止',
          value: 3
        }, {
          label: '已过期',
          value: 4
        }]
      }],
      formData: {
        name: '',
        time: '',
        state: ''
      },
      handleSearch: () => {},
      handleReset: () => {}
    });
    const dialogFormData = ref({});
    const priceData = ref([]);
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      loading: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      options: useTableOptions(),
      columnList: [{
        label: '序号',
        prop: 'serial'
      }, {
        label: '促销方案名称',
        prop: 'name'
      }, {
        label: '服务列表',
        prop: 'serviceList',
        formatter: val => {
          if (val.length) {
            let formateTextArr = [];
            val.forEach(item => {
              formateTextArr.push(item.name);
            });
            return formateTextArr.join(',');
          }
        }
      }, {
        label: '主品牌',
        prop: 'mainBrand'
      }, {
        label: '子品牌',
        prop: 'subBrand'
      }, {
        label: '状态',
        prop: 'state',
        formatter: val => {
          if (val !== null && val !== undefined) {
            return val == 1 ? t('促销中') : val == 2 ? t('未开始') : val == 3 ? t('中止') : t('已过期');
          }
        }
      }, {
        label: '促销周期',
        prop: 'promotionTime',
        formatter: val => {
          if (isArray(val)) {
            let formateVal = val.map(item => {
              return item.substring(0, 10);
            });
            return formateVal.join(t(' 至 '));
          }
        }
      }, {
        label: '编辑时间',
        prop: 'editTime'
      }, {
        label: '创建时间',
        prop: 'createTime'
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        buttonsList: [{
          label: '查看',
          func: row => {
            checkDetailDialog.visible = true;
            checkDetailDialog.loading = true;
            setTimeout(() => {
              dialogFormData.value = {
                name: 'VIP Package',
                createTime: '2023-05-14 01:00:00',
                period: '2023-05-10 00:00:00'.substring(0, 10) + ' ' + t('至') + ' ' + '2023-05-11 23:59:59'.substring(0, 10),
                promotionalProductName: 'FTV'
              };
              priceData.value = [{
                serviceList: [{
                  createTime: '2022-01-22 16:00:00',
                  updateType: '2022-01-22 16:00:00',
                  id: 1,
                  name: 'Data Service'
                }],
                period: 1,
                terminalName: '月卡',
                price: '10'
              }, {
                serviceList: [{
                  createTime: '2023-05-15 16:00:00',
                  updateType: '2023-05-15 16:00:00',
                  id: 2,
                  name: 'VIP Service'
                }],
                period: 3,
                terminalName: '3个月',
                price: '30'
              }];
              checkDetailDialog.loading = false;
            }, 1000);
          }
        }, {
          label: '复制',
          func: row => {}
        }, {
          label: '编辑',
          func: row => {}
        }, {
          label: '中止',
          func: row => {}
        }, {
          label: '恢复',
          func: row => {}
        }, {
          label: '关联子品牌',
          func: row => {
            clearData(actionForm.formData);
            actionForm.visible = true;
          }
        }]
      }],
      headerButtonsList: [{
        label: '新增',
        style: {
          'min-width': '120px'
        },
        func: () => {
          addOrEditPlan.visible = true;
        }
      }, {
        label: '促销日历',
        style: {
          'min-width': '120px'
        },
        func: () => {
          calenderDialog.visible = true;
        }
      }]
    });
    const calenderDialog = reactive({
      visible: false,
      dialogConfig: {
        title: '促销方案',
        destroyOnClose: true
      }
    });
    const actionForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '选择关联主品牌',
        prop: 'mainBrand',
        widgetType: 'Select',
        list: [{
          prefixName: '主品牌一',
          cid: 1
        }, {
          prefixName: '主品牌二',
          cid: 2
        }],
        required: true,
        filterable: true,
        labelKey: 'prefixName',
        valueKey: 'cid',
        onChange: val => {}
      }], [{
        label: '选择关联子品牌',
        prop: 'subBrand',
        widgetType: 'Select',
        multiple: true,
        list: [{
          label: '子品牌一',
          value: 11
        }, {
          label: '子品牌二',
          value: 22
        }],
        required: true,
        onChange: val => {}
      }]],
      formData: {
        mainBrand: '',
        subBrand: []
      },
      dialogConfig: {
        title: '关联子品牌',
        destroyOnClose: true
      },
      rules: {
        mainBrand: [{
          required: true,
          message: t('请选择主品牌'),
          trigger: 'change'
        }],
        subBrand: [{
          required: true,
          message: t('请选择子品牌'),
          trigger: 'change'
        }]
      },
      confirm: done => {
        formValidator(formRef.value.mForm).then(() => {
          done();
        }, () => done());
      }
    });

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    onMounted(() => {
      tableConfig.loading = true;
      setTimeout(() => {
        tableConfig.data = [{
          serial: 1,
          name: '端午节促销',
          serviceList: [{
            createTime: '2022-01-22 16:00:00',
            id: 1,
            name: 'TV Service',
            updateTime: '2022-01-22 16:00:00'
          }, {
            createTime: '2022-01-22 16:00:00',
            id: 2,
            name: 'Satellite Service',
            updateTime: '2022-01-22 16:00:00'
          }],
          mainBrand: '主品牌一',
          subBrand: '子品牌一',
          state: 1,
          promotionTime: ['2023-05-16 00:00:00', '2023-05-20 23:59:59'],
          editTime: '2023-05-16 00:00:00',
          createTime: '2023-05-16 00:00:00'
        }];
        tableConfig.loading = false;
      }, 1000);
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [!addOrEditPlan.visible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(Buttons, {
        class: "header-btns mg-b--20",
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_common_table, {
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: () => {}
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "options", "render"])])), [[_directive_loading, tableConfig.loading]])])) : _createCommentVNode("", true), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: calenderDialog.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => calenderDialog.visible = $event),
        "dialog-config": calenderDialog.dialogConfig,
        nativeConfig: {
          width: '90%',
          closeOnClickModal: false
        },
        isShowConfirm: false
      }, {
        default: _withCtx(() => [_createVNode(PromotionCalender)]),
        _: 1
      }, 8, ["modelValue", "dialog-config"]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '30%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          ref_key: "formRef",
          ref: formRef,
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"]), _createVNode(CheckDetailDialog, {
        modelValue: checkDetailDialog.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => checkDetailDialog.visible = $event),
        loading: checkDetailDialog.loading,
        "form-data": dialogFormData.value,
        "price-data": priceData.value
      }, null, 8, ["modelValue", "loading", "form-data", "price-data"]), addOrEditPlan.visible ? (_openBlock(), _createBlock(AddOrEditPlan, {
        key: 1,
        "return-back-fn": () => addOrEditPlan.visible = false
      }, null, 8, ["return-back-fn"])) : _createCommentVNode("", true)]);
    };
  }

});